var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      staticClass: "tabs",
      on: { "tab-click": _vm.handleClick },
      model: {
        value: _vm.abaAtiva,
        callback: function($$v) {
          _vm.abaAtiva = $$v
        },
        expression: "abaAtiva"
      }
    },
    [
      _c("el-tab-pane", { attrs: { name: "geral" } }, [
        _c("span", { attrs: { slot: "label", id: "GERAL" }, slot: "label" }, [
          _vm._v("Geral  ")
        ]),
        _c(
          "div",
          [_c("informacoes-cadastro", { attrs: { cadastroGleba: _vm.gleba } })],
          1
        )
      ]),
      _c("el-tab-pane", { attrs: { name: "cadastrante" } }, [
        _c(
          "span",
          { attrs: { slot: "label", id: "CADASTRANTE" }, slot: "label" },
          [_vm._v("Cadastrante  ")]
        ),
        _c(
          "div",
          [
            _c("informacoes-cadastrante", {
              attrs: { cadastroGleba: _vm.gleba }
            })
          ],
          1
        )
      ]),
      _c("el-tab-pane", { attrs: { name: "georreferenciamento" } }, [
        _c(
          "span",
          {
            attrs: { slot: "label", id: "GEORREFERENCIAMENTO" },
            slot: "label"
          },
          [_vm._v("Georreferenciamento  ")]
        ),
        _c(
          "div",
          [
            _c("informacoes-geo", {
              attrs: {
                cadastroGleba: _vm.gleba,
                isVisivel: _vm.abaAtiva === "georreferenciamento"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a490bb9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a490bb9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/bancoDados/gleba/TabsVisualizarGleba.vue
// module id = null
// module chunks = 